// Direction enum for 4-way sprites
export const Direction = {
    DOWN: 0, // Facing camera (front/south)
    LEFT: 1, // Facing left (west)
    RIGHT: 2, // Facing right (east)
    UP: 3, // Facing away (back/north)
};
// Animation states
export const AnimationState = {
    IDLE: 0,
    WALK: 1,
    WORK: 2,
    ATTACK: 3,
};
// Calculate velocity direction to Direction enum
export const velocityToDirection = ({ vx, vy }) => {
    // Use larger axis to determine primary direction
    if (Math.abs(vx) > Math.abs(vy)) {
        return vx > 0 ? Direction.RIGHT : Direction.LEFT;
    }
    return vy > 0 ? Direction.DOWN : Direction.UP;
};
// Calculate direction from position delta
export const deltaToDirection = ({ dx, dy }) => {
    if (dx === 0 && dy === 0) {
        return Direction.DOWN; // Default facing
    }
    return velocityToDirection({ vx: dx, vy: dy });
};
// Get opposite direction (for mirroring)
export const oppositeDirection = ({ direction }) => {
    switch (direction) {
        case Direction.DOWN:
            return Direction.UP;
        case Direction.UP:
            return Direction.DOWN;
        case Direction.LEFT:
            return Direction.RIGHT;
        case Direction.RIGHT:
            return Direction.LEFT;
        default:
            return Direction.DOWN;
    }
};
// Check if direction is horizontal
export const isHorizontalDirection = ({ direction }) => {
    return direction === Direction.LEFT || direction === Direction.RIGHT;
};
// Check if direction is vertical
export const isVerticalDirection = ({ direction }) => {
    return direction === Direction.UP || direction === Direction.DOWN;
};
//# sourceMappingURL=types.js.map